module.exports = __webpack_public_path__ + "static/media/03-chs.f86d305d.png";